import React, { useState, useEffect, FC, useRef } from 'react';
import './user-table-row.scss';
import { Checkbox } from 'primereact/checkbox';
import { Avatar } from 'primereact/avatar';
import { ContextMenu } from 'primereact/contextmenu';
import { Chip } from 'primereact/chip';
export interface UserTableRowProps {
    user_id: string;
    name: string;
    email: string;
    active: boolean,
    shops:any[];
    position: string;
    checked: boolean;
    picture: string;
    setChecked: (checked: boolean, id: string) => void;
    setUserToEdit: (props: any) => void;
    setWordToConfirm: (props: string) => void;
    setUserIdToDelete: (props: string) => void;
}
const roleLevelToName = {
    1: 'Employee',
    2: 'Manager',
    3: 'Super Manager'
}
const UserTableRow:FC<UserTableRowProps> = (props) => {
    const {user_id, name, picture, email, active, shops=[], position, checked, setChecked, setUserToEdit, setWordToConfirm, setUserIdToDelete} = props;
    const cm = useRef(null);
    const items = [
        { label: 'Edit', icon: 'pi pi-user-edit', command:()=>setUserToEdit(props)},
        { label: 'Delete', icon: 'pi pi-trash', command: ()=>{setUserIdToDelete(user_id);setWordToConfirm(name)} }
    ];

    return (
        <div className="user-table-row" onContextMenu={(e) => cm.current.show(e)}>
            <Checkbox onChange={e => setChecked(e.checked,user_id)} checked={checked}></Checkbox>
            
            <Avatar image={picture} shape="circle" className="user-table-row__photo" />
            <div className="user-table-row__info">
                <div className="user-table-row__info__name">
                    {name}
                </div>
                <div className="user-table-row__info__address">
                    {email}
                </div>
            </div>
            <div className={`user-table-row__status ${active ? 'active' : 'not-active'}`}>{active? 'Active' : 'Not active'}</div>
            <div className="user-table-row__shops">{shops.map(s => <div className="user-table-row__shops__one">{s.name}</div>)}</div>
            <div>
            <Chip label={roleLevelToName[position]} className="user-table-row__permissions" />
            <ContextMenu model={items} ref={cm} breakpoint="767px" />
            </div>
        </div>
    );
}
         
export default UserTableRow;